import { productSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

productSelectorStyles.clearIcon = {
    css: css`
        position: absolute;
        right: 40px;
        top: 40px;
        cursor: pointer;
    `,
};

productSelectorStyles.selectButton = {
    css: css`
        margin-top: 25px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 100%;
                    `,
                ],
                "max",
            )}
    `,
};
